"use strict";
// DEPRECATION NOTICE: prefer TimelineBodyWrapper (once TimelineBodyEditor is available) CRM-Issues/3655
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableRenderMixin = _interopRequireDefault(require("react-immutable-render-mixin"));

var _RichTextEditorModules = require("customer-data-rte/config/RichTextEditorModules");

var _connectRte = _interopRequireDefault(require("crm_ui/draftjs/connectRte"));

var _EngagementTypesType = _interopRequireDefault(require("crm_ui/engagements/EngagementTypesType"));

var _RequireAsync = _interopRequireDefault(require("crm_ui/mixins/RequireAsync"));

var _BodyContent = _interopRequireDefault(require("crm_ui/timeline/components/generic/BodyContent"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _GenericPluginGroup = _interopRequireDefault(require("draft-plugins/plugins/GenericPluginGroup"));

var _AttachmentPlugin = _interopRequireDefault(require("customer-data-rte/plugins/AttachmentPlugin"));

var _FileManagerAttachmentPlugin = _interopRequireDefault(require("customer-data-rte/plugins/FileManagerAttachmentPlugin"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var attachmentPluginTooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
  message: "customerDataCommunicator.InteractionWithValidatedAttachments.tooltip"
});

var TimelineInlineEditor = (0, _createReactClass.default)({
  displayName: 'TimelineInlineEditor',
  propTypes: {
    engagement: _propTypes.default.instanceOf(_EngagementRecord.default).isRequired,
    handleChange: _propTypes.default.func.isRequired,
    bodyText: _propTypes.default.string,
    config: _EngagementTypesType.default,
    body: _propTypes.default.node,
    handleStateCreated: _propTypes.default.func.isRequired,
    showRTEBorder: _propTypes.default.bool,
    validateFile: _propTypes.default.func,
    handleAddAttachment: _propTypes.default.func,
    richTextLoaded: _propTypes.default.func,
    subject: _SubjectType.default,
    showControls: _propTypes.default.bool,
    onSave: _propTypes.default.func,
    onCancel: _propTypes.default.func,
    controlSize: _propTypes.default.string,
    useTertiaryButtons: _propTypes.default.bool
  },
  mixins: [_reactImmutableRenderMixin.default, (0, _RequireAsync.default)([{
    names: _RichTextEditorModules.simpleRichTextEditorModules,
    callback: 'update'
  }])],
  getDefaultProps: function getDefaultProps() {
    return {
      handleStateCreated: _emptyFunction.default,
      onCancel: _emptyFunction.default,
      richTextLoaded: _emptyFunction.default
    };
  },
  setupRteConfig: function setupRteConfig() {
    var _this$props = this.props,
        handleAddAttachment = _this$props.handleAddAttachment,
        config = _this$props.config;

    if (!handleAddAttachment) {
      this.rteConfig = this.RichTextEditorDefaultConfigurations.getRteConfig(config);
      return null;
    }

    var query = {
      hidden: true
    };
    var attachmentPlugin = (0, _GenericPluginGroup.default)([(0, _AttachmentPlugin.default)({
      onAttachmentSelected: this.handleAttachmentSelected,
      fileOptions: {
        query: query
      },
      options: {
        enabled: true,
        tooltip: null
      }
    }), (0, _FileManagerAttachmentPlugin.default)({
      onAttachmentSelected: this.handleAttachmentSelected,
      query: query
    })], {
      icon: 'attach',
      inline: false,
      className: 'private-dropdown--list',
      tooltip: attachmentPluginTooltip,
      tooltipPlacement: 'bottom'
    });
    return this.rteConfig = this.RichTextEditorDefaultConfigurations.createRteConfig(config, [attachmentPlugin]);
  },
  update: function update() {
    this.SimpleRichTextEditor = (0, _connectRte.default)(this.SimpleRichTextEditor);
    this.props.richTextLoaded();
    this.setupRteConfig();
    return this.forceUpdate();
  },
  handleAttachmentSelected: function handleAttachmentSelected(file) {
    var _this$props2 = this.props,
        handleAddAttachment = _this$props2.handleAddAttachment,
        validateFile = _this$props2.validateFile;

    if (!file || !file.get('id')) {
      return null;
    }

    if (!handleAddAttachment || !validateFile || !validateFile(file)) {
      return null;
    }

    return handleAddAttachment(file);
  },
  render: function render() {
    var _this$props3 = this.props,
        engagement = _this$props3.engagement,
        bodyText = _this$props3.bodyText,
        handleChange = _this$props3.handleChange,
        body = _this$props3.body,
        handleStateCreated = _this$props3.handleStateCreated,
        subject = _this$props3.subject,
        useTertiaryButtons = _this$props3.useTertiaryButtons,
        showRTEBorder = _this$props3.showRTEBorder;
    var Component = this.SimpleRichTextEditor;

    if (!Component) {
      return _react.default.createElement("div", {
        className: "timeline-body full"
      }, _react.default.createElement(_BodyContent.default, null, body));
    }

    var editorBodyText = bodyText || engagement.getIn(['metadata', 'html']) || engagement.getIn(['metadata', 'body']) || '';
    return _react.default.createElement(Component, {
      associations: engagement.associations,
      subject: subject,
      focus: true,
      showRTEBorder: showRTEBorder,
      unstyled: true,
      value: editorBodyText,
      onChange: handleChange,
      onCancel: this.props.onCancel,
      config: this.rteConfig,
      pluginOptions: {
        spellCheck: true
      },
      onStateCreated: handleStateCreated,
      showControls: this.props.showControls,
      onSave: this.props.onSave,
      controlSize: this.props.controlSize,
      useTertiaryButtons: useTertiaryButtons
    });
  }
});
var _default = TimelineInlineEditor;
exports.default = _default;
module.exports = exports.default;